import { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const PromoContext = createContext();

export const PromoProvider = ({ children, initialData = [] }) => {
  const [promoMessages, setPromoMessages] = useState(initialData);
  const [loading, setLoading] = useState(initialData.length === 0);

  useEffect(() => {
    if (initialData.length > 0) return;
    const fetchPromoMessages = async () => {
      try {
        const res = await axios.get(
          `${import.meta.env.VITE_BACKEND_API_URL}/admin/get-all-promo-messages`
        );

        if (res.data.success) {
          setPromoMessages(res.data.promoMessages || []);
        }
      } catch (err) {
        console.error("Failed to fetch promo messages", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPromoMessages();
  }, [initialData]);

  const value = useMemo(
    () => ({ promoMessages, loading }),
    [promoMessages, loading]
  );

  return (
    <PromoContext.Provider value={value}>
      {children}
    </PromoContext.Provider>
  );
};

export const usePromo = () => useContext(PromoContext);